/*
 * Copyright (c) 2024 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Sunday, July 21st 2024, 8:23:11 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import create from "zustand";
import { TLocales } from "lib/schemas";

/** A Store for common usage */
interface ICommonStore {
  locales: TLocales;
  populateLocales: (locales: TLocales) => void;
}

export const useCommonStore = create<ICommonStore>((set) => {
  return {
    locales: {},
    populateLocales: (locales) => set((state) => ({ locales })),
  };
});
